import allFlags from '../config/featureFlags.json';

type FlagMap = Record<string, boolean>;
interface Config {
  common: FlagMap;
  [opco: string]: FlagMap;
}

const cfg = allFlags as Config;
const opco = process.env.GATSBY_OPCO!;

// Merge common + opco overrides
export const flags: FlagMap = {
  ...cfg.common,
  ...(cfg[opco] || {}),
};

// Helper to check
export const isEnabled = (flag: keyof FlagMap) => Boolean(flags[flag]);
